import * as ol from 'openlayers'
import BasePointAspect from './BasePointAspect'
import { translate } from '@/translation/native_translate.js';

export default class EntryPointAspect extends BasePointAspect {

  constructor(data) {
    super(data);
    this.set('type', 'EntryPoint'); //should match dss object type
    this.set('subType', data.subType);
    this.set('category', data.category);
    this.set('maxCapacity', data.maxCapacity);
    this.set('arrivalRateLimit', data.arrivalRateLimit);
    this.setZIndex(5);
  }

  createStyle() {
    return [
      new ol.style.Style({
        image: new ol.style.Icon(({
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: this.getImagePath("entrypoint/", 'entrypoint2'),
          anchor: [0.5, 0.5],
        }))
      })
    ];
  }

  createTooltip() {
    let text = "<div id='map-popup-tooltip'>";
    text += "<p class='pop-up-atribute' >Naam: " + this.get('referenceName') + "</p>";
    text += "<p class='pop-up-atribute' >Category: " + this.get('category') + "</p>";
    text += "<p class='pop-up-atribute' >Max Capacity: " + this.get('maxCapacity') + "</p>";
    text += "<p class='pop-up-atribute' >Arrival Rate Limit: " + this.get('arrivalRateLimit') + "</p>";
    text += "</div>";
    return text;
  }
  rightClick(pixel, gps, rightClickBehaviour = 0) {
    let forwardBehave = true;
    switch (rightClickBehaviour) {
      case 0: //normal behaviour

        break;
      case 1: //Relation creation
        forwardBehave = false;

        break;
    }

    if (forwardBehave) {
      let boxConfig = {
        customData: this.getObject(),
        gpsData: gps,
        parentId: 'ContextMenu',
        id: 'ContextMenu', //specific id for context menu box
        component: 'ContextMenu',
        name: "Menu",
        left: (pixel[0] + 10),
        top: (pixel[1] + 10 + 49), // +49 to adjust for navigation bar
        actions: [
          { 'id': '_removeAction', 'name': 'Remove', '_function': () => { this.removeObject(); } }
        ],
      }

      this.$emit('closeBoxMgr', 'ContextMenu');
      setTimeout(function() { this.$emit('openBoxMgr', boxConfig); }, 200);
    }
  }

  removeObject() {
    window.Event.vue.$confirm('WARNING_MESSAGE', 'WARNING_MESSAGE_TITLE', {
      confirmButtonText: translate('YES'),
      cancelButtonText: translate('NO'),
      type: 'warning'
    }).then(() => {
      var requestObject = {
        "childId": {
          "datatype": "string",
          "value": this.getId(),
        },
        "cleanDatabase": {
          "datatype": "bool",
          "value": true,
        }
      };

      if (this.get('parentId') === 'undefined') {
        this.$notify.error({
          title: "ENTRY_POINT_FAILS_TO_REMOVE",
          message: "ERROR",
          duration: 0
        });
      } else {
        this.setLastAction('removeObject');
        const request = dssUtility.createDSSRequest(this.get('parentId'), "cleanupChild", requestObject);
        window.socket.sendMessage(request, () => {
          window.Event.vue.$notify.success({
            title: "ENTRY_POINT_REMOVED",
            message: "Success"
          });
        });
      }
    });
  }

  static _objectDefinition() {
    return {
      locationAddress: '',
      locationName: '',
      locationType: '',
      locationPosition: '',
      capacity: '',
      entries: '',
      arrivalRate: '',
      arrivalRateSlot: '',
      road: '',
      house_number: '',
      postcode: '',
      city: '',
      country: '',
      country_code: '',
    };
  }

  static createRequestObject(object) {
    let requestObject = {
      "PositionCode": {
        "datatype": "string",
        "value": object.locationPosition,
      },
      "ReferenceName": {
        "datatype": "string",
        "value": object.locationName,
      },
      "DefaultCapacity": {
        "datatype": "int",
        "value": object.capacity,
      },
      "SubType": {
        "datatype": "string",
        "value": object.locationType,
      },
      "UserGroups": {
        "datatype": "table"
      },
      "ArrivalRateLimit": {
        "datatype": "int",
        "value": object.arrivalRate,
      },
      "DepartureRateLimit": {
        "datatype": "int",
        "value": 0,
      },
      "AmountOfEntries": {
        "datatype": "int",
        "value": object.entries,
      },
      "ArrivalRateSlot": {
        "datatype": "int",
        "value": Number(object.arrivalRateSlot),
      },
      "Street": {
        "datatype": "string",
        "value": object.road,
      },
      "Nr": {
        "datatype": "string",
        "value": object.house_number,
      },
      "PostalCode": {
        "datatype": "string",
        "value": object.postcode,
      },
      "City": {
        "datatype": "string",
        "value": object.city,
      },
      "Country": {
        "datatype": "string",
        "value": object.country,
      },
      "CountryCode": {
        "datatype": "string",
        "value": object.country_code,
      }
    };

    return requestObject;
  }
}
